/**
 * 用户协议页（`/terms` · N 域 N5）
 *
 * 🔴 路由挂在 `Shell` **之外**：未登录（注册前）也必须能读 —— 这是合规要求，不是体验优化。
 * 文案与"每条能否被产品行为验证"的备注见 `features/legal-content.ts`。
 */

import type { ReactElement } from 'react';
import { LegalDoc } from '../ui/LegalDoc.js';
import { PRIVACY_TITLE, TERMS_SECTIONS, TERMS_TITLE } from '../features/legal-content.js';

export function TermsPage(): ReactElement {
  return (
    <LegalDoc
      title={TERMS_TITLE}
      sections={TERMS_SECTIONS}
      sibling={{ label: PRIVACY_TITLE, to: '/privacy' }}
      testId="terms-page"
    />
  );
}
